/**
 * 获取 domain
 */
 export default (url: string) => {
    url = url || window.location.host;
    const domain = url.includes("localhost")
      ? "localhost"
      : url.includes(".jdcloud.com")
      ? ".jdcloud.com"
      : url.includes(".beijing.egov.cn")
      ? ".beijing.egov.cn"
      : ".beijing.gov.cn";
    return domain;
  };
  